<template>
  <div>
    <div class="primary font-semibold pb-3">
      Timeline
    </div>
    <TimelineEvents
      class="custom-timeline"
      :timelineEvents="data"
      :finalPointColour="orderStatusToColorMap[status]"
      textSmall
    />
  </div>
</template>
<script setup lang="ts">
import TimelineEvents from '@/components/timeline.vue';
import { orderStatusToColorMap } from '@/helpers/category_color_mapper';

interface Props {
  data: { eventType: string; eventAt: string }[];
  status: string;
}

defineProps<Props>();
</script>

<style scoped lang="scss">

.custom-timeline :deep .content {
  @apply text-base;
}

</style>
